export const hts = [
  {
    name: 'tariffNumber',
    label: 'Tariff Number',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'description',
    label: 'Description',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'dutyComputationCode',
    label: 'Duty Computation Code',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'spiCode',
    label: 'Special Programs Indicator Code',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'pgaFlags',
    label: 'PGA',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'beginDate',
    label: 'Begin Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'endDate',
    label: 'End Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'transactionCode',
    label: 'Status',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'lastUpdatedDate',
    label: 'Last Update Date',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

export const htsField  = [
  {
    name: 'tariffNumber',
    label: 'Tariff Number',
    type: 'text',
    maxLength: 10,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'description',
    label: 'Description',
    type: 'text',
    maxLength: 30,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'beginDate',
    label: 'Begin Date',
    type: 'date',
    maxLength: null,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'endDate',
    label: 'End Date',
    type: 'date',
    maxLength: null,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'numReportingUnits',
    label: 'Number of Reporting Units',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'unit1',
    label: 'Unit 1',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'unit2',
    label: 'Unit 2',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'unit3',
    label: 'Unit 3',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'dutyComputationCode',
    label: 'Duty Computation Code',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'col1SpecificRate',
    label: 'Column 1 Specific Rate',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'baseRateIndicator',
    label: 'Base Rate Indicator',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'transactionCode',
    label: 'Transaction Code',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  // V2 fields
  {
    name: 'col1RateAdValorem',
    label: 'Column 1 Rate Ad Valorem',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'col1RateOther',
    label: 'Column 1 Rate Other',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'col2RateSpecific',
    label: 'Column 2 Rate Specific',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'col2RateAdValorem',
    label: 'Column 2 Rate Ad Valorem',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'col2RateOther',
    label: 'Column 2 Rate Other',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'countervailingDutyFlag',
    label: 'Countervailing Duty Flag',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'additionalTariffNumIndicator',
    label: 'Additional Tariff Number Indicator',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'miscPermitLicenseIndicator',
    label: 'Misc Permit License Indicator',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  // V3 fields
  {
    name: 'gspExcludedCountries',
    label: 'GSP Excluded Countries',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'antidumpingDutyFlag',
    label: 'Antidumping Duty Flag',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'quotaIndicator',
    label: 'Quota Indicator',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'categoryNumber',
    label: 'Category Number',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'spiCode',
    label: 'SPI Code',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  },
  {
    name: 'pgaFlags',
    label: 'PGA Flags',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'hts',
  }
];

export const htsRateTaxFormFields = [
  {
    name: 'countryCode',
    label: 'Country Code',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'specificSpecialRate',
    label: 'Specific Special Rate',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'adValoremSpecialRate',
    label: 'Ad Valorem Special Rate',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'otherSpecialRate',
    label: 'Other Special Rate',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'taxFeeClassCode',
    label: 'Tax Fee Class Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'taxFeeComputationCode',
    label: 'Tax Fee Computation Code',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'taxFeeFlag',
    label: 'Tax Fee Flag',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'taxFeeSpecificRate',
    label: 'Tax Fee Specific Rate',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
  {
    name: 'taxFeeAdValorem',
    label: 'Tax Fee Ad Valorem',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: 0,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'htsRateTax',
  },
];
